import React from "react";

const Index = ({handleSmoothScroll, isMenuOpen, isScrolled}) => {
  return (
    <div
      className={`md:hidden w-full max-h-screen text-center py-4 overflow-hidden transition-all duration-500 ease-in-out ${
        isMenuOpen ? "max-h-screen block" : "max-h-0 hidden"
      } ${isScrolled ? "bg-primary text-white" : "bg-white text-primary"}`}
    >
      <ul className="space-y-4">
        <li>
          <a
            href="#features"
            className="text-lg font-semibold hover:text-blue-400"
            onClick={handleSmoothScroll}
          >
            Features
          </a>
        </li>
        <li>
          <a
            href="#about"
            className="text-lg font-semibold hover:text-blue-400"
            onClick={handleSmoothScroll}
          >
            About
          </a>
        </li>
        <li>
          <a
            href="#contact"
            className="text-lg font-semibold hover:text-blue-400"
            onClick={handleSmoothScroll}
          >
            Contact
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Index;
